

/**
 * 
 * @param {*} target
 * @param {*} p0 
 * @param {*} p1 
 */
function isPointAt (target, p0, p1) {
  let maxAllowOffsetLength = 15
  const A = p1.y- p0.y
  const B = p0.x - p1.x
  const C = p1.x * p0.y - p0.x* p1.y
  // 点到直线的距离方程
  let dis = Math.abs(A * target.x + B * target.y + C) / Math.sqrt(Math.pow(A, 2) + Math.pow(A, 2))
  if (dis > maxAllowOffsetLength) {
    return false
  } else {
    const D = (A * target.y - B * target.x);
    const jiaoX = -(A * C + B *D) / (Math.pow(B, 2) + Math.pow(A, 2));
    //判断jiaoX是否在线段上，t如果在0~1之间说明在线段上，大于1则说明不在线段且靠近端点p1，小于0则不在线段上且靠近端点p0，这里用了插值的思想
    const t = (jiaoX - p0.x) / (p1.x - p0.x);
    if (t > 1  || isNaN(t)) {
    //最小距离为到p1点的距离
      dis = getLengthOfTwoPoint(p1, target);
    }else if (t < 0){
    //最小距离为到p2点的距离
      dis = getLengthOfTwoPoint(p0, target);
    }
    //再次判断真正的最小距离是否小于允许值，小于则该点在直线上，反之则不在
    if (dis <= maxAllowOffsetLength) {
      return true;
    } else {
      return false;
    }
  }
}
/**
 * 
 * @param {*} targetPoint 
 * @param {*} srcRect 
 * @returns 
 */
function isContained(targetPoint, srcRect) {
  let x = targetPoint.x
  let y = targetPoint.y
  let width = Math.abs(srcRect.x1 - srcRect.x2)
  let height = Math.abs(srcRect.y1 -srcRect.y2)
  let distanceX1 = Math.abs(x - srcRect.x1)
  let distanceX2 = Math.abs(x - srcRect.x2)
  let distanceY1 = Math.abs(y - srcRect.y1)
  let distanceY2 = Math.abs(y - srcRect.y2)
  if ((distanceX1 + distanceX2) > width || (distanceY1 + distanceY2) > height) {
    return false
  }
  return true
}

//这里是求两点距离公式
function getLengthOfTwoPoint(point1, point2){
  return Math.sqrt(Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2));
}

export {
  isPointAt,
  isContained
}